import Link from 'next/link';
import SocialMediaIcons from './SocialMediaIcons';

const Footer: React.FC = () => {
  return (
    <>
      <footer id="footer">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-4">
              <h4>Kontakt</h4>
              <p>
                Fachhochschule Nordwestschweiz FHNW
                <br />
                Corporate IT
                <br />
                Multimedia &amp; Communications
                <br />
                Bahnhofstrasse 6<br />
                5210 Windisch
              </p>
              <p>
                E-Mail: <a href="mailto:webmaster@fhnw.ch">webmaster@fhnw.ch</a>
              </p>

              <SocialMediaIcons />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 order-first order-md-0">
              <h4>Über diese Website</h4>
              <p>
                Der Web-Styleguide der FHNW bildet das verbindliche
                Standard-Design der FHNW-Webdienste ab und erlaubt, dieses auf
                Basis eines Bootstrap5-Frameworks in der Webentwicklung zu
                nutzen.
              </p>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <h4>Quicklinks</h4>
              <p>
                <Link href="/corporate-design/webdienste/" legacyBehavior>
                  <a title="Webdienste">Webdienste</a>
                </Link>
                <br />
                <Link href="/cd/tools-und-services/" legacyBehavior>
                  <a title="Tools und Services">Tools und Services</a>
                </Link>
                <br />
                <a href="#">Quicklinks</a>
              </p>
            </div>
          </div>
        </div>
        <div className="container tools__footer">
          <div className="row">
            <div className="d-flex justify-content-center">
              <p>
                <Link href="https://www.fhnw.ch" legacyBehavior>
                  <a target="_blank">www.fhnw.ch</a>
                </Link>
                <span className="d-inline-block mx-1 mx-md-2">|</span>
                <Link href={'https://www.fhnw.ch/de/impressum'} legacyBehavior>
                  <a target="_blank">Impressum</a>
                </Link>
                <span className="d-inline-block mx-1 mx-md-2">|</span>
                <Link
                  href={'https://www.fhnw.ch/de/impressum/datenschutz'}
                  legacyBehavior
                >
                  <a target="_blank">Datenschutz</a>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
